var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("StepTitle", [_vm._v("Asociar Actividades")]),
      _c("v-divider"),
      _c("CabeceraTabla", {
        scopedSlots: _vm._u([
          {
            key: "izquierda",
            fn: function() {
              return [
                _c("BuscadorOperacionCrud", {
                  attrs: {
                    filter:
                      _vm.gridApi &&
                      _vm.gridApi.setQuickFilter.bind(_vm.gridApi)
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("TiposActividadGrid", {
        attrs: {
          value: _vm.value,
          readonly: _vm.readonly,
          esEditar: _vm.esEditar
        },
        on: {
          input: _vm.handleValueChange,
          gridApiChange: _vm.handleGridApiChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }